/* eslint-disable prefer-const */
//* remove page scroll position
//* https://developers.google.com/web/updates/2015/09/history-api-scroll-restoration
if ('scrollRestoration' in window.history) {
  // Back off, browser, I got this...
  window.history.scrollRestoration = 'manual';
}
//* Force at top position when page loaded
document.scrollTop = 0;

//* some const variable, can be us across the whole site
const mobileBp = 600;
const tabletBp = 900;
const tabletHzt = 1200;
const defaultEasing = BezierEasing(0.075, 0.82, 0.165, 1); // should be same as css one

//* service worker in use
//* disable if not needed
const needSW = false;
if ('serviceWorker' in navigator && needSW) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('sw.js').then((registration) => {
      // Registration was successful
      // console.log('ServiceWorker registration successful with scope: ', registration.scope);
    }, (err) => {
      // registration failed :(
      // console.log('ServiceWorker registration failed: ', err);
    });
  });
}

//* Detect device has hover or not
function watchForHover() {
  let hasHoverClass = false;
  const container = $('body');
  let lastTouchTime = 0;

  function enableHover() {
    // filter emulated events coming from touch events
    if (new Date() - lastTouchTime < 500) return;
    if (hasHoverClass) return;

    container.addClass('hasHover');
    hasHoverClass = true;
  }

  function disableHover() {
    if (!hasHoverClass) return;

    container.removeClass('hasHover');
    hasHoverClass = false;
  }

  function updateLastTouchTime() {
    lastTouchTime = new Date();
  }

  document.addEventListener('touchstart', updateLastTouchTime, true);
  document.addEventListener('touchstart', disableHover, true);
  document.addEventListener('mousemove', enableHover, true);

  enableHover();
}

watchForHover();

//* debounce function
// Credit David Walsh (https://davidwalsh.name/javascript-debounce-function)

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  let timeout;

  return function executedFunction() {
    const context = this;
    const args = arguments;

    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    const callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
}


let happeningsPageBuyTicketAction = false;
let happeningsPageBuyTicket = false;
let happeningsPageBuyTicketUrl = null;
let happeningsPageCurrentUrl = null;
let tasteDetail = false;
let touristCard = false;

const apiLink = $('body').data('api-link');
